import React from "react";
import { useNavigate } from "react-router-dom";
import PContent from "../../../../../atoms/text/PContent";
import type { MobileSubmenuItem } from "../types/mobileNavigation";

interface MobileSubmenuProps {
  items: MobileSubmenuItem[];
}

const MobileSubmenu: React.FC<MobileSubmenuProps> = ({ items }) => {
  const navigate = useNavigate();

  const handleItemClick = (item: MobileSubmenuItem, event: React.MouseEvent) => {
    if (item.onClick) {
      event.preventDefault();
      item.onClick();
    } else if (item.href) {
      event.preventDefault();
      navigate(item.href);
    }
  };

  return (
    <div className="flex flex-col space-y-3 py-2 pl-4">
      {items.map((item, index) => (
        <a
          key={index}
          href={item.href || "#"}
          onClick={(event) => handleItemClick(item, event)}
          className="flex items-center space-x-2 text-sm text-gray-600 transition-colors hover:text-primary"
        >
          <PContent>{item.icon}</PContent>
          <PContent className="font-semibold hover:font-bold">{item.label}</PContent>
        </a>
      ))}
    </div>
  );
};

export default MobileSubmenu;
